/**
 * Stable fingerprint for the active session user (organization switch, impersonation, logout).
 * @param {{ connected?: boolean, user?: { id?: number|null }, entity?: { id?: number|null }, impersonated?: boolean }|null|undefined} loginInfo
 * @returns {string}
 */
export function getActiveUserFingerprint(loginInfo) {
    if (!loginInfo?.connected) {
        return "disconnected";
    }

    const userId = loginInfo.user?.id ?? "none";
    const entityId = loginInfo.entity?.id ?? "none";
    const impersonated = loginInfo.impersonated ? "1" : "0";

    return `${userId}:${entityId}:${impersonated}`;
}

export const LOGIN_INFO_POLL_INTERVAL_MS = 60 * 1000;

export const ACTIVE_USER_CHANGED_MESSAGES = {
    fr: {
        title: "Utilisateur actif modifié",
        text: "L'utilisateur actif a été modifié. Le navigateur va recharger la page.",
        confirmButtonText: "OK",
    },
    en: {
        title: "Active user changed",
        text: "The active user has changed. The browser will reload the page.",
        confirmButtonText: "OK",
    },
};
